module.exports = __webpack_public_path__ + "assets/img/img_2011.e4580702.jpg";